@if (baseElement.isVisible) {
  <mat-radio-group
    [value]="baseElement.data ?? value"
    [name]="name ?? ''"
    (change)="onGroupChange($event)"
    [class]="groupClass"
  >
    @for (opt of resolvedOptions; track opt.value) {
      <div class="radio-wrapper" [ngClass]="'label-position-' + labelPosition">
        <mat-radio-button
          [value]="opt.value"
          [disabled]="isOptionDisabled(opt)"
          [attr.aria-label]="opt.label"
          [labelPosition]="materialLabelPosition"
          (click)="onOptionClick($event, opt.value)"
        >
          <span class="radio-option-content">
            {{ opt.label }}
            @if (opt.tooltip) {
              <mat-icon
                [matTooltip]="opt.tooltip | transloco"
                matTooltipPosition="above"
                class="radio-option-tooltip-icon"
              >
                help_outline
              </mat-icon>
            }
          </span>
        </mat-radio-button>
      </div>
    }
  </mat-radio-group>
}
